window.CaseStudiesShowcase = () => {
    return {
        caseStudyOpened: false,
        caseStudyType: null,
        caseStudySelected: null,
    };
};
